import { lazyLoad } from 'utils/loadable';

export const CalendarRedirectPage = lazyLoad(
  () => import('./index'),
  module => module.CalendarRedirectPage,
);
